const palette = {
  common: {
    black: '#000',
    white: '#fff',
    transparent: 'rgba(0, 0, 0, 0)',
    fullBlack: 'rgba(0, 0, 0, 1)',
    darkBlack: 'rgba(0, 0, 0, 0.87)',
    lightBlack: 'rgba(0, 0, 0, 0.54)',
    minBlack: 'rgba(0, 0, 0, 0.26)',
    faintBlack: 'rgba(0, 0, 0, 0.12)',
    fullWhite: 'rgba(255, 255, 255, 1)',
    darkWhite: 'rgba(255, 255, 255, 0.87)',
    lightWhite: 'rgba(255, 255, 255, 0.54)',
  },
  primary: {
    50: '#E7F8FD',
    100: '#b7eafb',
    150: '#44cbf8',
    200: '#4D9AFF',
    300: '#2D93BA',
    400: '#27A2DB',
    500: '#10BAF2',
    600: '#05AFE7',
    700: '#00A9E1',
    800: '#4A90E2',
    900: '#0076FF',
    950: '#0059CF',
    A100: '#E3EDF1',
    A200: '#E8EDF2',
    A400: '#CBDADF',
    A700: '#C6C5CB',
    contrastDefaultColor: 'light',
  },
  secondary: {
    50: '#96A9B4',
    100: '#BBC6D1',
    150: '#6D8394',
    200: '#7D91A0',
    250: '#586E85',
    300: '#557083',
    350: '#4A5F76',
    400: '#3A556A',
    450: '#405869',
    500: '#26303c',
    600: '#333F4C',
    650: '#3A4750',
    700: '#171F2F',
    // 800: '#17222E',
    800: '#081B2C',
    900: '#08273C',
    A100: '#487EA1',
    A200: '#3C58BF',
    A400: '#293688',
    A700: '#051244',
    contrastDefaultColor: 'light',
  },
  grey: {
    50: '#F3F3F3',
    100: '#F7F9FB',
    200: '#E5E5E5',
    300: '#DADADA',
    400: '#D8D8D8',
    500: '#979797',
    600: '#8A99A1',
    650: '#8C97A2',
    700: '#5C6A72',
    800: '#424242',
    900: '#212121',
    A100: '#d5d5d5',
    A200: '#aaaaaa',
    A400: '#303030',
    A700: '#616161',
    contrastDefaultColor: 'dark',
  },
  validation: {
    50: '#FFF3F4',
    100: '#fff3f4',
    200: '#EC8457',
    300: '#ffa2a7',
    500: '#ff4650',
    600: '#EF3D4D',
    900: '#A50020',
    contrastDefaultColor: 'light',
  },
  notification: {
    50: '#FFFFAF',
    100: '#FCD462',
    300: '#FFB356',
    500: '#ffbc00',
    700: '#F7981D',
    800: '#ED7C00',
    900: '#FF6D00',
    contrastDefaultColor: 'light',
  },
  add: {
    50: '#F7FAFC',
    500: '#069898',
    600: '#0DA99B',
    700: '#22A8A5',
    800: '#58D6FF',
    contrastDefaultColor: 'light',
  },
  active: {
    50: '#E8EEF4',
    200: '#a3ffd6',
    500: '#3ecf8e',
    800: '#258e5d',
    contrastDefaultColor: 'light',
  },
  future: {
    500: '#cf70ea',
    contrastDefaultColor: 'light',
  },
  states: {
    intake: '#FF6D00',
    delivery: '#10BAF2',
    billing: '#3ecf8e',
    collection: '#cf70ea',
    paid: '#22A8A5',
    rejected: '#ff4650',
    archive: '#8A99A1',
  },
  text: {
    // primary: '#17222E',
    primary: '#081B2C',
    //#1C0637
  },
};

export default palette;


// WEBPACK FOOTER //
// ./src/styles/palette.js